import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaFilm,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const DocumentaryAndShortFilmProductionInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Documentary and Short Film Production in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Tell Your Story</Subheading>}
        heading={
          <Heading>
            Documentary & Short Film{" "}
            <span tw="text-primary-500">Production</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we excel in documentary and short film production
            in **DIFC**, crafting cinematic, narrative-driven, and visually
            stunning films that captivate audiences. From impactful
            documentaries to compelling short films, we bring stories to life
            with authenticity and creativity.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1617599797605-c7604e367732?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1569937756447-1d44f657dc69?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1604514813560-1e4f5726db65?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Film"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Cinematic Documentary & Short Film Production in DIFC"
        description="We create films that resonate and inspire."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description:
              "Visually stunning films with professional production.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven success with DIFC clients and festivals.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Storytelling",
            description: "Narratives that connect with audiences.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Timely production for festivals and campaigns.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description:
              "Optimized for streaming, social media, and screenings.",
          },
          {
            icon: <FaFilm color="#ff5464" size={40} />,
            title: "Versatile Formats",
            description: "Documentaries, shorts, and branded films.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Documentary & Short Film Production Process"
        description={
          <Description>
            We produce unforgettable films with a meticulous process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your story and creative vision.</li>
              <li>
                Pre-Production: Develop scripts, storyboards, and logistics.
              </li>
              <li>
                Filming: Capture authentic moments with high-end equipment.
              </li>
              <li>
                Post-Production: Edit with sound design, color grading, and
                effects.
              </li>
              <li>Delivery: Provide polished films ready for release.</li>
              <li>Support: Offer guidance for distribution and promotion.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1649768092591-d9a0851b9b81?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1601506521937-0121a7fc2a6b?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1601978473813-4f0f650b421c?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Documentary & Short Film Wins in DIFC"
        description="Our films have inspired audiences in DIFC and beyond."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Festival Recognition",
            description: "Films screened at regional and global events.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Audience Impact",
            description: "Increased engagement on streaming platforms.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% approval from film production projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Tell Your Story?</Subheading>}
        heading="Documentary & Short Film Production in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for documentary and short film
            production in DIFC. Create cinematic, impactful films that resonate
            with audiences—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1593697821252-0c9137d9fc45?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1541943869728-4bd4f450c8f5?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1493804714600-6edb1cd93080?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
